import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { GalleryIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/promos-offer/promotional-banner')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="promoManagement.promotionalBanners.crumb" icon={GalleryIcon} />,
      title: <Translation id="promoManagement.promotionalBanners.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
